export const MAPS_API_KEY = "AIzaSyBB3CtMh2A1HucpgGN4Re30iDAoGmfT3WI";

export const MARKER = {
    lat: -33.8975322,
    lng: 151.2107304
}
